import { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import RecordsPage from "./pages/RecordsPage";
import PersonDetailPage from "./pages/PersonDetailPage";
import CompanyDetailPage from "./pages/CompanyDetailPage";
import SequencesPage from "./pages/SequencesPage";
import SequenceDetailPage from "./pages/SequenceDetailPage";
import ContentCalendarPage from "./pages/PlannedContentPage";
import { SocialProfilesPanel } from "./components/content-parts";
import api from "./api";
import TasksPage from "./pages/TasksPage";
import ApiPage from "./pages/ApiPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import MailboxPage from "./pages/MailboxPage";
import CronJobsPage from "./pages/CronJobsPage";
import { Toaster } from "./components/ui/toaster";
import { Loader2 } from "lucide-react";

function Shell() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-white text-[hsl(240,6%,10%)]">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <div className="flex-1 overflow-auto">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/people" element={<RecordsPage type="people" />} />
            <Route path="/people/:id" element={<PersonDetailPage />} />
            <Route path="/companies" element={<RecordsPage type="companies" />} />
            <Route path="/companies/:id" element={<CompanyDetailPage />} />
            <Route path="/deals" element={<RecordsPage type="deals" />} />
            <Route path="/social-profiles" element={<SocialProfilesPanel api={api} />} />
            <Route path="/sequences" element={<SequencesPage />} />
            <Route path="/sequences/:id" element={<SequenceDetailPage />} />
            <Route path="/mailbox" element={<MailboxPage />} />
            <Route path="/content" element={<ContentCalendarPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/automations" element={<CronJobsPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/developers" element={<ApiPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function Protected() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-[hsl(245,58%,60%)]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Shell />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<Protected />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
